export enum SEARCH_BOX_ACTION {
  CLICK = "click",
  CHAR = "character"
}
